import React from 'react';
import styled from '@benzinga/themetron';
import { type DeviceType } from '@benzinga/device-utils';

const CallToActionForm = React.lazy(() =>
  import('@benzinga/forms-ui').then(module => {
    return { default: module.CallToActionForm };
  }),
);

export interface NewsletterBoxProps {
  description: string;
  deviceType: DeviceType;
  form_id: string;
  full_width?: boolean;
  mobileOnly?: boolean;
  redirect_url: string;
  style: string;
  title: string;
}

export const NewsletterBoxBlock: React.FC<NewsletterBoxProps> = ({
  description,
  deviceType,
  form_id,
  full_width,
  mobileOnly,
  redirect_url,
  style,
  title,
}) => {
  const styleOption =
    style === 'fusion-article-india' ? 'secondary-article-india' : style === 'fusion' ? 'secondary' : 'default';
  return !(mobileOnly && deviceType !== 'mobile') ? (
    <NewsletterBoxWrapper className={`block ${full_width ? 'full' : ''}`}>
      <CallToActionForm
        beehiivFormId={form_id}
        fullWidth={full_width}
        redirectUrl={redirect_url}
        styleOption={styleOption}
        subtitle={description}
        title={title}
      />
    </NewsletterBoxWrapper>
  ) : null;
};

export const NewsletterBoxWrapper = styled.div`
  max-width: 360px;
  margin: auto;
  &.full {
    max-width: 100%;
  }
`;
